import './index.css'
import AllPages from './Components/AllPages';
export default function App() {
  return (<>
  <AllPages/>
  </>
 );
}
